package app.nestbridge.feature.careteam.api.model

import kotlinx.serialization.Serializable

@Serializable
enum class TeamRelationshipRoleDto {
    ORGANIZER,
    THERAPIST,
    PARENT,
    OBSERVER,
}
